import { IFermentation } from '../types/fermentation';

const serialize = (data: any) => {
  if (data && data.length > 0) return data[0];
  return '';
};

const createFermentation = (res: any): IFermentation => {
  const {
    desc,
    created_at,
    modified_at,
    fermented_at,
    scale_type,
    result_stat,
    image_volume,
    method_attributes,
    created_locally_at,
    user_correction_enabled,
    dilution_sample,
    dilution_sample_1,
    dilution_sample_2,
    dilution_stain,
    dilution_stain_1,
    dilution_stain_2,
    batch_count,
    tags,
    ...rest
  } = res;

  const parsedTags = {
    oculyzeWineType: serialize(tags?.tag?.oculyze_wine_type),
    tankVolume: serialize(tags?.tag?.tank_volume),
    tank: serialize(tags?.tag?.tank),
    grapeVariety: serialize(tags?.tag?.grape_variety),
    yeastBrand: serialize(tags?.tag?.yeast_brand),
    yeastStrain: serialize(tags?.tag?.yeast_strain),
    nutrientsAtFillIn: serialize(tags?.tag?.nutrients_at_fill_in),
    additivesAtFillIn: serialize(tags?.tag?.additives_at_fill_in),
    vineyardSource: serialize(tags?.tag?.vineyard_source),
    yeastGeneration: serialize(tags?.tag?.yeast_generation),
  };

  return {
    ...rest,
    description: desc,
    scaleType: scale_type,
    resultStat: result_stat,
    imageVolume: image_volume,
    createdAt: new Date(created_at),
    modifiedAt: modified_at ? new Date(modified_at) : null,
    fermentedAt: fermented_at ? new Date(fermented_at) : null,
    locallyCreatedAt: created_locally_at ? new Date(created_locally_at) : null,
    userCorrectionEnabled: user_correction_enabled,
    methodAttributes: {
      stain: parseInt(method_attributes.stain),
      analysisLevel: parseInt(method_attributes.analysis_level),
    },
    dilutionSample: dilution_sample,
    dilutionSample1: dilution_sample_1,
    dilutionSample2: dilution_sample_2,
    dilutionStain: dilution_stain,
    dilutionStain1: dilution_stain_1,
    dilutionStain2: dilution_stain_2,
    batchCount: batch_count,
    tags: parsedTags,
  };
};

export default createFermentation;
